<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/?page=expenses"></top-nav-bar>

        <div v-if="expense && (expense.status.value === 'rejected' || expense.status.value === 'pending')">
            <form class="max-w-sm mx-auto px-4 overflow-y-auto pb-16 md:pb-0 py-2"
                  @submit.prevent="save"
                  v-if="expense">
                <h3 class="text-center mb-8">Update expense</h3>

                <expense-form v-model="expense"
                              @activeFileUpload="activeFileUpload"></expense-form>

                <div class="block md:inline-flex md:float-right">
                    <button class="btn btn--colored__blue w-full"
                            :disabled="disabled"
                            :class="{'disabled': disabled}"
                            type="submit">
                        <i class="fal fa-spin fa-circle-notch" v-if="disabled"></i>
                        Update Expense
                    </button>
                </div>
            </form>
        </div>

        <div v-else class="py-10 text-center">
            <i class="fal fa-exclamation-triangle"></i>
            Only rejected or pending expenses may be edited
        </div>
    </div>
</template>

<script>
    import ExpenseForm from '@/partials/expenses/Form.vue';
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [CanAccessView],
        components: {
            ExpenseForm
        },

        data() {
            return {
                expense: null,
                disabled: false,
            }
        },

        mounted() {
            this.$api('expenses').get(this.$route.params.expense)
                .then(({data}) => {
                    this.expense = data.data;
                });
        },

        methods: {
            activeFileUpload(value) {
                this.disabled = !value;
            },

            save() {
                if (this.disabled) {
                    return;
                }

                let form = new FormData();

                if (!this.expense.type) {
                    return this.$noty.error('Please select a type before submitting.');
                }

                Object.keys(this.expense).forEach(key => {
                    if (key === 'id') {
                        return;
                    }

                    if (key === 'attachments') {
                        this.expense.attachments.forEach((attachment, index) => {
                            if (attachment.hasOwnProperty('response')) {
                                form.append(`${key}[${index}]`, attachment.response.data.id);
                            }
                        });

                        return;
                    }

                    if (Array.isArray(this.expense[key])) {
                        this.expense[key].forEach((value, index) => {
                            form.append(`${key}[${index}]`, value);
                        });
                    } else {
                        form.append(key, this.expense[key]);
                    }
                });

                this.disabled = true;

                this.$api('expenses').post(`${this.expense.id}`, form)
                    .then(() => {
                        this.$router.replace('/expenses');
                        this.disabled = false;
                    })
                    .catch(error => {
                        this.expense.attachments = this.expense.attachments.map((attachment, index) => {
                            if (error.response.data.errors.hasOwnProperty('attachments.' + index)) {
                                attachment.error = error.response.data.errors['attachments.' + index][0];
                                attachment.success = false;
                            } else {
                                attachment.error = false;
                                attachment.success = true;
                            }

                            return attachment;
                        });

                        this.$noty.error('An error occurred');
                        this.disabled = false;
                    });
            }

        }
    }
</script>
